import { NavLink } from 'react-router-dom'
import React from 'react'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'
import CircleCount from '../CircleCount/CircleCount'
import { IconName } from '@fortawesome/fontawesome-svg-core'

export interface TabOptionProps {
    label: string
    route: string
    icon?: IconName | undefined
    count?: number
    disabled?: boolean
}

interface TabNavLinkProps {
    options: TabOptionProps[]
    className?: string
    navLinkClasses?: string
}

const TabNavLink: React.FunctionComponent<TabNavLinkProps> = ({ options, className, navLinkClasses }) => {
    return (
        <div className={`flex px-6 text-lg border-b overflow-x-auto w-full gap-x-6 ${className ? className : ''}`}>
            {options.map((option: TabOptionProps, optionIndex: number) => {
                return (
                    <NavLink
                        key={optionIndex}
                        to={option.route}
                        end={option.route === ''}
                        className={({ isActive }) =>
                            `pt-4 pb-2 text-base font-semibold border-b-2 min-w-fit flex items-center space-x-2 transition-all ${
                                isActive
                                    ? 'text-[--tb-mainHeading] border-[--tb-primary]'
                                    : 'border-transparent text-[--tb-textLight] hover:border-b-[--tb-primary] hover:opacity-100 opacity-75'
                            } ${navLinkClasses ? navLinkClasses : ''} ${
                                option.disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''
                            }`
                        }
                    >
                        {option.icon && <DynamicFaIcon iconName={option.icon} />}
                        <span className='w-full'>{option.label}</span>
                        {option.count != null && option.count > 0 && <CircleCount count={option.count} />}
                    </NavLink>
                )
            })}
        </div>
    )
}

export default TabNavLink
